import api from "./api";

export const getResources = async (params = {}) => {
  try {
    const res = await api.get("/resources/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching resources:", error);
    throw error;
  }
};

export const getResourceById = async (id) => {
  try {
    const res = await api.get(`/resources/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching resource:", error);
    throw error;
  }
};

export const createResource = async (data) => {
  try {
    const formattedData = {
      label: data.label,
      url: data.url,
      type: data.type,
      productSlug: data.productSlug || null,
      createdAt: new Date().toISOString()
    };
    
    console.log("Sending resource data:", formattedData);
    const res = await api.post("/resources/", formattedData);
    return res.data;
  } catch (error) {
    console.error("Error creating resource:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const updateResource = async (id, data) => {
  try {
    const formattedData = {
      label: data.label,
      url: data.url,
      type: data.type,
      productSlug: data.productSlug || null,
      updatedAt: new Date().toISOString()
    };
    
    console.log("Updating resource data:", formattedData);
    const res = await api.put(`/resources/${id}`, formattedData);
    return res.data;
  } catch (error) {
    console.error("Error updating resource:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deleteResource = async (id) => {
  try {
    const res = await api.delete(`/resources/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting resource:", error);
    throw error;
  }
};
